var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6422 8.15117L11.0797 5.30742C11.033 5.25551 10.9734 5.21353 10.9055 5.18464C10.8375 5.15575 10.763 5.14071 10.6875 5.14062H9.675C9.57031 5.14062 9.5125 5.2459 9.57656 5.31836L11.8313 7.82031H2.375C2.30625 7.82031 2.25 7.86953 2.25 7.92969V8.75C2.25 8.81016 2.30625 8.85938 2.375 8.85938H13.2484C13.6672 8.85938 13.9 8.43828 13.6422 8.15117Z",
    fill: "#6F6F76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6422 8.15117L11.0797 5.30742C11.033 5.25551 10.9734 5.21353 10.9055 5.18464C10.8375 5.15575 10.763 5.14071 10.6875 5.14062H9.675C9.57031 5.14062 9.5125 5.2459 9.57656 5.31836L11.8313 7.82031H2.375C2.30625 7.82031 2.25 7.86953 2.25 7.92969V8.75C2.25 8.81016 2.30625 8.85938 2.375 8.85938H13.2484C13.6672 8.85938 13.9 8.43828 13.6422 8.15117Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapRightIcon);
export default __webpack_public_path__ + "static/media/swapRightIcon.74ec27977dc552c2cda59f59343cbaae.svg";
export { ForwardRef as ReactComponent };